import { render, staticRenderFns } from "./HistoricSearchHTML.vue?vue&type=template&id=15a2d250&scoped=true&"
import script from "./HistoricSearchHTML.vue?vue&type=script&lang=ts&"
export * from "./HistoricSearchHTML.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricSearchHTML.vue?vue&type=style&index=0&id=15a2d250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2d250",
  null
  
)

export default component.exports